import React, { useEffect, useRef } from "react"
import { graphql, PageProps, useStaticQuery } from "gatsby"

import { Layout } from "@interia/common/components/layout"
import Seo from "../components/seo/seo"
import useMainPageData from "../hooks/useMainPageData"
import { Brands, CsrList, Intro, Mission, People, Statistics, Informations, Posts, PostsExtra, Career } from "../components/sections"
import useMainMenu from "../hooks/useMainMenu"
import useFooter from "../hooks/useFooter"

type DataProps = {
  site: {
    siteMetadata: {
      title: string
    }
  }
}

const IndexPage = ({ data: { site } }: PageProps<DataProps>) => {
  const siteTitle = site.siteMetadata.title
  const { informations, intro, mission, csr, brands, statistics, posts, postsExtra, career, openGraph } = useMainPageData()
  const afterSection = useRef<null | HTMLDivElement>(null);
  const headerRef = useRef<null | HTMLElement>(null);
  const menuItems = useMainMenu()
  const footer = useFooter()

  const handleScroll = () => {
    const headerHeight = headerRef.current?.clientHeight ?? 0;
    const afterSectionPosition = afterSection.current?.offsetTop ?? 0
    window.scrollTo({
      top: afterSectionPosition - headerHeight, behavior: 'smooth'
    });
  };


  return (
    <Layout footer={footer} gemiusId='0nKacee.fzah6lJ8915YdYZR7FlRDyyXVPlG5jJtFhH.P7' logoUrl={{ external: false, url: '/' }} menuItems={menuItems} ref={headerRef}>
      <Seo title={siteTitle} openGraph={openGraph} />
      {intro.active && <Intro
        title={intro.title}
        background={intro.background.backgroundvideo}
        backgroundMobile={intro.background.backgroundvideomobile}
        onScroll={handleScroll}
        imageBackground={intro.imagebackground.imagebackgrounddesktop}
        imageBackgroundMobile={intro.imagebackground.imagebackgroundmobile}
      />}
      <div ref={afterSection}>
        {mission.active && <Mission title={mission.title} description={mission.description} />}
        {informations.active && <Informations title={informations.title} informations={informations.informations} />}
        {statistics.active && <Statistics
          title={statistics.title}
          statistics={statistics.statistics}
        />}
        {career.active && <Career title={career.title} description={career.description} button={career.button} image={career.image} />}
        {csr.active && <CsrList title={csr.title} sections={csr.sections} />}
        {posts.active && <Posts title={posts.title} url="/aktualnosci/1" buttontext={posts.buttontext ?? ''} />}
        {postsExtra.active && <PostsExtra buttontext={postsExtra.buttontext} title={postsExtra.title} url={postsExtra.url} textimage={postsExtra.textimage} />}
        {brands.active && <Brands title={brands.title} description={brands.description} brands={brands.brands} buttontext={brands.buttontext} />}
      </div>
    </Layout>
  )
}

export default IndexPage

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`
